import React from 'react'
import { connect } from 'react-redux'
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle
} from '@mui/material'
import pick from 'lodash.pick'
import merge from 'lodash.merge'
import { initUser } from '../../lib/user'
import { formUpdate } from '../../lib/form'
import { sendWs, USER } from '../../lib/send'
import { rxOpenPlaySetting } from '../../lib/rx_subject'
import FormWithButton from '../../components/FormWithButton'
import SettingForm from './SettingForm'
import './PlaySetting.scss'

const args = ['name', 'memo', 'chatAnswer', 'color', 'delay']

const PlaySetting = ({ user }) => {
  const [open, setOpen] = React.useState(false)

  const formEl = React.createRef()

  const [form, setForm] = React.useState(pick(initUser, args))

  React.useEffect(() => {
    const subscription = rxOpenPlaySetting.subscribe(() => {
      setOpen(true)
    })

    return () => {
      subscription.unsubscribe()
    }
  }, [])

  const onEnter = () => {
    setForm(pick(user, args))
  }

  const change = formUpdate(setForm)

  const submit = evt => {
    evt.preventDefault()

    if (formEl.current && !formEl.current.reportValidity()) {
      return
    }

    setOpen(false)
    sendWs(USER, merge({}, user, form))
  }

  const close = () => {
    setOpen(false)
  }

  return (
    <Dialog className="play-setting-dialog" open={open}
            TransitionProps={{ onEnter }}
            aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">プレイ設定</DialogTitle>
      <DialogContent className="play-setting">
        <FormWithButton ref={formEl} onSubmit={submit}>
          <SettingForm form={form} change={change} />
        </FormWithButton>
      </DialogContent>
      <DialogActions className="dialog-actions">
        <form onSubmit={submit}>
          <Button type="submit" className="submit" color="primary">
            設定
          </Button>
          <Button className="close" color="secondary" onClick={close}>
            閉じる
          </Button>
        </form>
      </DialogActions>
    </Dialog>
  )
}

export default connect(
  state => ({
    user: state.user
  })
)(PlaySetting)
